import React, { FunctionComponent } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import styles from './EmptyPage.module.scss';

export const EmptyPage: FunctionComponent = () => {
  return (
    <div className={styles['faq__empty-page']}>
      <FontAwesomeIcon icon={['fal', 'inbox']} size="3x" className="text-muted" />
      <p className="text-muted">There are no articles in this section yet </p>
    </div>
  );
};
